import {COUNTRIES_WITH_VAT, COUNTRIES_WITH_VAT_OLD} from '../../components/Checkout/constants';
import {Experiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../common/constants';
import {CartModel} from '../models/checkout/Cart/Cart.model';
import {vatIdTypeMapV1, VatType} from '../models/checkout/Cart/VatId.model';
import {WixCommonVatType} from '../../gql/graphql';
import {flipMap} from './mapperHelper.utils';

export const getVatType = (type?: string): VatType => {
  switch (type) {
    /* istanbul ignore next */ case 'CPF':
      return /* istanbul ignore next */ VatType.CPF;
    case 'CNPJ':
      return /* istanbul ignore next */ VatType.CNPJ;
    /* istanbul ignore next */ default:
      return /* istanbul ignore next */ VatType.UNSPECIFIED;
  }
};

export const vatTypeToGQLVatType: Record<VatType, WixCommonVatType> = flipMap(vatIdTypeMapV1);

export const isCountryWithVAT = (cart: CartModel, experiments?: Experiments) => {
  const billingCountry = cart.paymentInfo.address?.country ?? '';
  const shippingCountry = cart.deliveryInfo?.address?.country ?? '';

  if (experiments?.enabled(SPECS.ShowVatIdOnBillingForIsrael)) {
    return COUNTRIES_WITH_VAT.includes(billingCountry) || COUNTRIES_WITH_VAT.includes(shippingCountry);
  } else {
    return COUNTRIES_WITH_VAT_OLD.includes(billingCountry) || COUNTRIES_WITH_VAT_OLD.includes(shippingCountry);
  }
};
